export const IrregularityState = {
    NOT_FIXED: 'NOT_FIXED',
    FIXED: 'FIXED',
    EXPIRED: 'EXPIRED',

    values: () => {
        return ['NOT_FIXED', 'FIXED', 'EXPIRED'];
    }
}